export default __webpack_public_path__ + "static/jardin4-c3c63b58af1254f0591059854a66ecc5.png";